import { Box, Button, Circle, Text } from "@chakra-ui/react";

export default function IndividualActivityCard({ activity, info }) {
    const Icon = info.icon
    return (
        <Box
            w='100%'
            d='flex'
            alignItems={['flex-start', 'flex-start', 'center']}
            py='1rem'
            borderBottom='1px solid rgba(0, 0, 0, 0.1)'
            justifyContent='space-between'
            flexDir={['column', 'column', 'row']}
        >
            <Box
                color='#333333'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                display='flex'
                justifyContent='flex-start'
                alignItems='center'
                mb={['3', '3', '0']}
            >
                <Circle
                    bg={info.bgColor}
                    size='50px'
                    mr='1.5rem'
                    d={['none', 'none', 'flex']}
                >
                    <Icon width='24px' height='24px' fill='white' />
                </Circle>

                <Box>
                    <Text fontWeight='700' fontSize={['14px', '16px', '16px', '16px']}>
                        {activity.description}
                    </Text>
                    {
                        activity.time &&
                        <Text fontWeight='600' color='#666666' fontSize={['12px', '14px', '16px', '16px']}>
                            {activity.time}
                        </Text>
                    }
                </Box>

            </Box>
            <Box w={['100%', '100%', '17%', '14%']} d='flex' justifyContent='center' alignItems='center'>
                {
                    activity.status === 'E' ? <Button
                        color='#ffffff'
                        bg={info.color}
                        boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                        borderRadius='10px'
                        padding='10px 20px'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        _hover={{ bg: 'linear-gradient(90.57deg, rgba(217, 130, 43, 0.7) 3.35%, #D9822b 94.78%)' }}
                        fontWeight='800'
                        fontSize={['12px', '12px', '12px', '14px', '16px']}
                        textTransform='uppercase'
                    >
                        Start Course
                    </Button>
                        :
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontWeight='800'
                            fontSize={['12px', '14px', '14px', '16px', '18px']}
                            color={info.color}
                            cursor='pointer'
                        >
                            View Details
                        </Text>

                }
            </Box>

        </Box>
    )
}